export const filterOrdersForTodayPU = (orders, specificDate) => {
    const today = new Date(specificDate);
    today.setHours(0, 0, 0, 0);

    return orders.filter(order => {
        const collecteDate = order.dateCollecte?.toDate();
        collecteDate.setHours(0, 0, 0, 0);
        return collecteDate.getTime() === today.getTime() && order.etat === 'valider';
    });
}